module.exports = __webpack_public_path__ + "static/media/x.bf218f8a.png";